import { Skeleton } from "./ui/Skeleton";

export function ProductCardSkeleton () {
  return (
    <Skeleton className="tw-max-w-full tw-w-full tw-min-w-[260px] tw-h-[360px] tw-bg-gray-200/50 tw-animate-pulse" />
  )
};